<template>
  <div class="animated fadeIn list-of-fa_disposal">
    <b-card v-show="showList">
      <div slot="header">List of Fixed Assets Disposed  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm" :disabled="disabledDelete">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="approvalConfirm()">
              <i class="fa fa-paper-plane"></i> Approval
          </button>
          <button class="btn btn-primary mr-1" @click="posting()">
              <i class="fa fa-paper-plane"></i> <span v-if="terpilih.posting==1">Un Posting </span> <span v-else>Posting </span>
          </button>
          <button class="btn btn-primary mr-1" @click="printjv()">
              <i class="fa fa-print"></i> Print JV
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Disposal Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgldepr1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgldepr2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>    
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Disposal Description</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.disposeNm" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Status &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.status" :plain="true" :options="approvalStatus"></b-form-select>
                  </b-input-group>
                </b-col>
            </b-row>    
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Group/Category</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.catgid" :plain="true" :options="categories"></b-form-select>
                    </b-input-group>
                  </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">PO # &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomorpo" placeholder="Purch. Order#"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>            
        </b-col>
        <b-col lg="6">
              <b-row no-gutters>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Number | Description</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asetid" placeholder="FA Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                      <b-form-input v-model="tblData.asdesc" placeholder="FA Name/Description"></b-form-input>
                </b-col>
              </b-row>                      
              <b-row no-gutters>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Model/Type/Series</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asmodel" placeholder="Model/Type/Series"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="3">
                      <b-form-input v-model="tblData.asserial" placeholder="Serial Number"></b-form-input>
                </b-col>
                <b-col lg="3" >
                    <b-button class="btn btn-secondary ml-3" @click="clearFilter()" > <i class="fa fa-eraser"></i> Clear Filter</b-button>
                </b-col>
              </b-row>                      
              <b-row no-gutters>
                <b-col lg="9">
                  <b-input-group >
                    <b-input-group-prepend><label>FA Acquisition Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3" >
                    <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(action)="data">
           <b-dropdown dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret size="sm" style="margin:-10px;">
            <template v-slot:button-content>
               <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item @click="rowEdit(data.item)" href="#" style="padding:0 !important;"><span v-if="((data.item.send2wf == 1) && (data.item.isreviewed != 1))">View</span><span v-else>Edit</span></b-dropdown-item>
            <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print JV</b-dropdown-item>
            <b-dropdown-item @click="rowPost(data.item)" href="#" style="padding:0 !important;">Approval</b-dropdown-item>
            <b-dropdown-item @click="rowDel(data.item)" href="#" style="padding:0 !important;"> Delete</b-dropdown-item>
            <b-dropdown-item @click="rowAttachment(data.item)" href="#" style="padding:0 !important;">Attachment</b-dropdown-item>
          </b-dropdown>
        </template>
        <template v-slot:cell(tgldispos)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{data.item.tgldispos| moment('D-MMM-YY')}} 
          </div>
          <div v-else> 
          {{data.item.tgldispos| moment('D-MMM-YY')}} 
          </div>
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>
        </template>
        <template v-slot:cell(aspurcpri)="data">
          {{data.item.aspurcpri|numFormat}}
        </template>
        <template v-slot:cell(lastDepr)="data">
          <span v-if="(data.item.lastDepr)">{{data.item.lastDepr| moment('D-MMM-YY')}}</span>
        </template>
        <template v-slot:cell(Penyusutan)="data">
          {{data.item.Penyusutan|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(NilaiNett)="data">
          {{data.item.NilaiNett|numFormat('0,0.00')}}
        </template>

      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary" title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                      <b-input-group-prepend><label>FA Number</label></b-input-group-prepend>
                      <b-form-input v-model="terpilih.asetid" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="7">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Disposal Date</label></b-input-group-prepend>
                      <b-input-group-append>
                        <label class="input-group-text">
                          {{ terpilih.tgldispos | moment("DD MMM YYYY") }}
                        </label>
                      </b-input-group-append>
                  </b-input-group>
              </b-col>
          </b-row>  
          <b-row>
              <b-col md="12">
                  <b-input-group>
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                      <b-form-input v-model="terpilih.disposeNm" placeholder="Disposal Description" readonly></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row>    
          <div v-if="(this.terpilih.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                </tr>
                <tr> <td colspan="5" class="subtotal"></td></tr>
                </tbody>
                </table>
            </div>
            <b-row class="justify-content-center mt-1" >
                <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                <b-button variant="danger" class="ml-1" v-if="((terpilih.iscomplete==0) || (terpilih.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </div>
        <div no-body v-else>
          <label>Add Attachment</label>
            <b-form-file
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            ></b-form-file>
            <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
            <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                <label style="width:260px !important;">Send without attachment, are you sure?</label>
                  <b-form-radio-group v-model="confirmNoFile" class="ml-1" >
                      <b-form-radio :value="true">Yes</b-form-radio>
                      <b-form-radio :value="false">No</b-form-radio>
                  </b-form-radio-group>
            </b-row>
            <b-row class="justify-content-center mt-1" >
                <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
      <b-modal
        v-model="showAttachment"
        header-bg-variant="primary"
        title="Attachment"
        size="lg"
        :centered="true"
        ok-only
      >
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>FA Number</label></b-input-group-prepend
              >
              <b-form-input v-model="terpilih.asetid" readonly></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <div class="report-wraper">
          <table width="100%">
            <thead>
              <tr>
                <th width="200px">Attached Date</th>
                <th>File Name</th>
                <th width="100px">Attached By</th>
                <th width="40px">action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in attachmens" :key="row.attachmentKey">
                <td>
                  {{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
                </td>
                <td>
                  <b-link @click="attachmentDownload(row)">{{
                    row.attchFileNm
                  }}</b-link>
                </td>
                <td>{{ row.createby }}</td>
                <td>
                  <div class="text-center" v-if="terpilih.iscomplete == 0">
                    <a
                      href="javascript:void(0)"
                      class="text-danger"
                      @click="delAttachment(row)"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div no-body v-if="terpilih.iscomplete == 0">
          <label>Add Attachment</label>
          <b-form-file
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <b-row class="mt-1" v-if="file">
            <span class="p-2"
              >Selected File:
              <strong>{{ file ? file.name : "" }}</strong> Filesize:{{
                bytesToKB.showFileSize(file)
              }}</span
            >
            <b-button
              variant="success"
              @click="attachmentSave"
              class="sm"
              ><i class="fa fa-paperclip"></i> Add Attachment</b-button
            >
          </b-row>
        </div>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Form - Disposal Fixed Asset  
        <div class="card-header-actions">
          <b-button variant="primary" @click="save()" v-if="(model.send2wf==0) || (model.posting==0) || (model.send2wf==1 && model.isreviewed==1)"><i class="fa fa-save"></i> Save</b-button>
          <b-button variant="secondary" class="ml-1" @click="closeFrm()"><i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="6">
          <b-row>
            <b-col lg="6">                            
              <b-input-group>
                <b-input-group-prepend><label>Disposal Date</label></b-input-group-prepend>
                <b-form-input v-model="model.tgldispos" type="date" :state="!$v.model.tgldispos.$error" @change="tanggalBerubah"></b-form-input>                                        
              </b-input-group>
            </b-col>
            <b-col lg="6">
                <b-input-group >
                    <b-input-group-prepend><label>Disposal Trx.Number</label></b-input-group-prepend>
                    <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                </b-input-group>
            </b-col>   

          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Disposal Description</label></b-input-group-prepend>
            <b-form-input v-model="model.disposeNm" :state="!$v.model.disposeNm.$error" placeholder="Description/Note Disposal Asset"></b-form-input>                                        
          </b-input-group>
          <b-row>
            <b-col xl="8">
              <b-input-group>
                <b-input-group-prepend><label>Nilai Lelang</label></b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
                </b-input-group-prepend>
                <my-number class="form-control text-right" separator="," v-model="model.nilailelang" :precision="2"></my-number>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label style="width:200px !important;">Gain/Loss Disposal Account#</label></b-input-group-prepend>
            <b-form-input readonly v-model="model.disposaccinfo" :state="!$v.model.disposacc.$error"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="showLkuCoa('disposacc')"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group v-if="(model.nilailelang)">
            <b-input-group-prepend><label style="width:200px !important;">Receivable/Payable Account#</label></b-input-group-prepend>
            <b-form-input readonly v-model="model.arapaccinfo" :state="!$v.model.arapacc.$error"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="showLkuCoa('arapacc')"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <hr />
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="m-0">Disposed Fixed Asset  ({{model.lines.length}}) Items</h5>
        <b-button variant="success" size="sm" @click="lkuFixedAssetShow=true">
          <i class="fa fa-plus"></i> Add Fixed Asset
        </b-button>
      </div>

      <b-table
        outlined responsive hover small
        style="font-size:smaller;"
        :items="model.lines"
        :fields="lineFields"
      >
        <template v-slot:cell(action)="data">
          <b-button variant="outline-danger" size="sm" @click="removeLine(data.index)">
            <i class="fa fa-trash"></i>
          </b-button>
        </template>
        <template v-slot:cell(asserial)="data">
          {{ data.item.asserial }}
          <span v-if="data.item.asmodel"> &nbsp; | &nbsp; Model/Type: {{ data.item.asmodel }}</span>
        </template>

        <template v-slot:cell(asdatacq)="data">
          <span v-if="data.item.asdatacq">{{ data.item.asdatacq | moment('D-MMM-YY') }}</span>
        </template>
        <template v-slot:cell(aspurcpri)="data">
          {{ data.item.aspurcpri | numFormat }}
        </template>
        <template v-slot:cell(Penyusutan)="data">
          {{ data.item.Penyusutan | numFormat('0,0.00') }}
        </template>
        <template v-slot:cell(NilaiNett)="data">
          {{ data.item.NilaiNett | numFormat('0,0.00') }}
        </template>
      </b-table>
        <b-row class="justify-content-center mt-2">
            <b-button variant="primary" @click="save()" v-if="(model.send2wf==0) || (model.posting==0) || (model.send2wf==1 && model.isreviewed==1)"><i class="fa fa-save"></i> Save</b-button>
            <b-button variant="secondary" class="ml-1" @click="closeFrm()"><i class="fa fa-close"></i> Close</b-button>
        </b-row> 
    </b-card>

    
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" outstand="1" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>    
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>     
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    <b-modal v-model="showReport" size="xl" scrollable  title="Preview as PDF" hide-footer>
        <iframe :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>

  </div>
</template>

<style lang="scss">
    .list-of-fa_disposal {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: 120px;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import fa_disposal from "../../apis/fa_disposal";
import task from "../../apis/task";
import dropdown from "../../data/dropdown";
import bytesToKB from "../../libs/filesize-byte2kb";
import myNumber from "../../components/my-number";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import lkuCoa from "../lookup/lkuCoa";
import { validationMixin } from "vuelidate";
import { required, minValue,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuFixedasset, lkuCoa },
  mixins: [validationMixin],
  validations: {
        model: {
          tgldispos: { required },
          disposeNm: { required },
          disposacc: { required},
          arapacc: { required},
            arapacc: {required : (function() {
                if ((this.model.nilailelang || 0) == 0) {
                    return true;
                } else if ((this.model.arapacc || '')==''){
                    return false;
                } else return true;
            })},

        },
  },
  data() {
    return {
      isLoading:false,
      lkuFixedAssetData:{},
      lkuFixedAssetShow: false,
      lkuCoaShow:false,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      showApprovalConfirm: false,
      showConfirmNoFile: '',
      confirmNoFile: false,
      showApprovalCancelConfirm: false,
      showAttachment: false,
      attachmens: [],
      bytesToKB,
      approvalHistory: [],
      approvalStatus: dropdown.approvalStatus,
      file: null,
      disabledDelete: false,
      showList:true,
      showForm:false,
      showFilter:false,
      showReport:false,
      isprintjv:false,
      reportUrl: `${location.origin}/#load`,
      tblData: {
        items: [],
        status: "",
        page: 1,
        limit: 15,
        total: 0,
        tgldepr1: null,
        tgldepr2: null,        
        sortBy: null,
        sortDesc: false
      },
      terpilih:{disposekey:''},
      model: { tgldispos: this.$store.state.user.tglaktif, disposeNm: '', disposacc: '', lines: [] },
      uanguser: this.$store.state.user.matauang,
      YesNoAll: dropdown.YesNoAll,
      lkuCoaCaller: 'disposacc',
      categories: [],
      categoriesFrm: [],
      lineFields: [
        { key: "action", label: "", thStyle: "width:40px", thClass: "text-center", tdClass: "text-center" },
        { key: "asetid", label: "FA Number", thStyle: "width:100px", sortable: true },
        { key: "asdesc", label: "FA Name/Description" },
        { key: "asserial", label: "S/N & Model/Type" },
        { key: "catgname", label: "Category" },
        { key: "asdatacq", label: "Acquisition", thStyle: "width:90px" },
        { key: "aspurcpri", label: "Original Cost", thClass: "text-right", tdClass: "text-right" },
        { key: "Penyusutan", label: "Accum. Depr.", thClass: "text-right", tdClass: "text-right" },
        { key: "NilaiNett", label: "Nett Value", thClass: "text-right", tdClass: "text-right" },
      ]
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "action",
            label: "",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          {
            key: "nomor",
            thStyle: "width:120px",
            label: "Disposal Number",
            sortable: true
          },
          {
            key: "tgldispos",
            thStyle: "width:80px",
            label: "Disposal Date",
            sortable: true
          },
          {
            key: "disposeNm",
            label: "Disposal Description",
          },
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name/Description",
          },
          {
            key: "catgname",
            label: "Category",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "lastDepr",
            thStyle: "width:80px",
            label: "Ending Depreciate",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "Penyusutan",
            label: "Accumulate Depreciated",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "NilaiNett",
            label: "Nett Value Asset",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aspurcpri",
            label: "Aquisition Value",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "issuccess",
            thStyle: "width:120px",
            label: "Approval Status",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.model.$touch();
      return this.$v.model.$invalid || !this.model.lines || this.model.lines.length === 0;
    },

  },
  created: async function(){
      const [a] = await Promise.all([fa_disposal.category()]) ;
        this.categories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
      
      this.categoriesFrm=a;
      // this.adjustGroups = b;
  },  
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    // },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tgldispos).format('YYYY');
    },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.fadisposeList) {
            this.tblData[key] = filter.fadisposeList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.fadisposeList.tgl1 || '';
          this.tblData.tgl2=filter.fadisposeList.tgl2 || '';
          this.showFilter=filtered;
          delete filter.fadisposeList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await fa_disposal.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table)  this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.tgldepr1 ='';
      this.tblData.tgldepr2 ='';
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.keterangan=  '';
        this.tblData.vendor=  '';
        this.tblData.DimVal=  '';
        this.tblData.status=  '';
        this.refresh();
    },
    add: function(data) {
      this.model = {
        disposekey: '',
        tgldispos: moment(this.$store.state.user.tglaktif,'YYYY-MM-DD').endOf("month").format('YYYY-MM-DD'),
        disposeNm: '',
        nilailelang: 0,
        disposacc: '',
        disposaccinfo: '',
        arapacc: '',
        arapaccinfo: '',
        send2wf:0,
        isreviewed:0,
        posting:0,
        lines: []
      };
      this.showList = false;
      this.showForm = true;
    },
    edit: async function() {
      if (this.terpilih.disposekey) {
        this.isLoading = true;
        try {
          const detailData = await fa_disposal.detail(this.terpilih);
          const hdr = detailData.header || detailData;
          const lines = detailData.lines || [];
          this.model = Object.assign({}, hdr);
          this.model.tgldispos = moment(hdr.tgldispos).format('YYYY-MM-DD');
          this.model.lines = lines;
          this.tanggalBerubah();
          this.showForm = true;
          this.showList = false;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          toastr.error(error.message || JSON.stringify(error), "ERROR MESSAGE");
        }
      } else {
        toastr.warn('Please select a row that want to be Edit!');
      }
    },
    saveFilter() {
      const keys = ['asetid', 'asdesc', 'catgid',  'tgl1', 'tgl2', 'DimCol', 'DimVal', 'nomorpo', 'tgldepr1', 'tgldepr2','uraian', 'status'];
      let filtered = false;
      const fadisposeList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              fadisposeList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          fadisposeList.page=this.tblData.page;
          fadisposeList.limit=this.tblData.limit;
          fadisposeList.sortBy=this.tblData.sortBy;
          fadisposeList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.fadisposeList=fadisposeList;
          this.$store.commit("filter", filter);
      }
    },    

    onSelectLkuFixedAsset(lkuData) {
      this.lkuFixedAssetData = lkuData;
      this.lkuFixedAssetShow = false;
      const sel = lkuData.selected;
      if (!sel) return;

      // console.log('this.model.lines before: ', this.model.lines);
      if (!this.model.lines) {
        this.$set(this.model, 'lines', []);
      }
      
      const exists = this.model.lines.some(r => r.asetkey === sel.asetkey);
      if (exists) {
        toastr.warn(`Fixed Asset ${sel.asetid} is already added in lines.`);
        return;
      }

      this.model.lines.push({
        asetkey: sel.asetkey,
        asetid: sel.asetid,
        asdesc: sel.asdesc,
        asmodel: sel.asmodel,
        asserial: sel.asserial,
        catgname: sel.catgname,
        asdatacq: sel.asdatacq ? moment(sel.asdatacq).format('YYYY-MM-DD') : '',
        aspurcpri: sel.aspurcpri || 0,
        Penyusutan: sel.Penyusutan || 0,
        NilaiNett: (sel.aspurcpri || 0) - (sel.Penyusutan || 0)
      });
      // console.log('this.model.lines after: ', this.model.lines);
      // this.$forceUpdate();
    },
    removeLine(index) {
      this.model.lines.splice(index, 1);
    },
    rowEdit(record) {
      this.terpilih = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
      this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.printjv();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },    
    rowAttachment(record) {
      this.terpilih = record;
      this.getAttachment(record);
    },
    getAttachment: async function (record) {
      try {
        this.terpilih = record;
        this.isLoading = true;
        const data = await task.getAttachment({ taskkey: record.disposekey });
        this.attachmens = data;
        this.showAttachment = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    attachmentSave: async function (evt) {
      evt.preventDefault();
      if (!this.file) {
        toastr.error("Please choose a file");
      } else {
        toastr.info(`Attachment Save`);
        this.isLoading = true;
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
          formData.append("tablekey", this.terpilih.disposekey);
          formData.append("tableName", "asset_dispose");
          formData.append("filesize", bytesToKB.showFileSize(this.file));
          const response = await task.attachmentSave(formData);
          console.log("response : ", response);
          const data = await task.getAttachment({
            taskkey: this.terpilih.disposekey,
          });
          this.attachmens = data;
          this.file = null;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    attachmentDownload: async function (fl) {
      this.isLoading = true;
      try {
        await task.attachmentDownload(fl);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    delAttachment: async function (obj) {
      const pesan = `Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal
        .msgBoxConfirm(pesan, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value == true) {
            this.isLoading = true;
            try {
              await task.delAttachment(obj);
              const data = await task.getAttachment({
                taskkey: this.terpilih.disposekey,
              });
              this.attachmens = data;
              this.isLoading = false;
            } catch (error) {
              this.isLoading = false;
              console.log("error : ", error);
              if (error.sql) {
                toastr.error(error.sql, "ERROR MESSAGE", 10000);
              } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
              } else if (error.message) {
                toastr.error(error.message, "ERROR MESSAGE", 10000);
              } else {
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
              }
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    approvalConfirm: async function () {
        if (this.terpilih.disposekey) {
            this.showApprovalConfirm = true;
            if (this.terpilih.send2wf == 1) {
              try {
                const data = await task.approvalhistory({ key: this.terpilih.disposekey });
                this.approvalHistory = data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message, 'ERROR MESSAGE', 10000);
                } else {
                    toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
                }                
              }
            }
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault();
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile == false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile = true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.terpilih.disposekey);
            this.showApprovalConfirm = false;
            this.isLoading = true;
            const resp = await fa_disposal.approval(formData);
            this.terpilih.send2wf = 1;
            this.refresh();
            this.isLoading = false;
            if (resp.message) {
                toastr.warn(resp.message, 'warning', 10000);
            }
        } catch (error) {
            this.isLoading = false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE', 10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading = true;
        try {
            await fa_disposal.approvalUndo(this.terpilih);
            this.terpilih.send2wf = 0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE', 10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.terpilih.disposekey) {
          try {
              this.isprintjv = false;
              this.showReport = true;
              this.reportUrl = await task.approvalprint({ key: this.terpilih.disposekey });
              if (this.$isMobile()){
                  this.showReport = false;              
                  window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              this.model.tgldispos=moment(this.model.tgldispos).format('YYYY-MM-DD');

              await fa_disposal.save(this.model);
              this.model.disposekey='';
              this.closeFrm();    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm() {
      if (this.terpilih.disposekey) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await fa_disposal.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
    },
    rowClicked(record, index) {
        if (record.status === '111') {
          this.disabledDelete = true;
        } else {
          this.disabledDelete = false;
        }
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    posting: async function () {
      if (this.terpilih.disposekey) {
            if ((this.terpilih.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.terpilih.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            for (var key in this.terpilih) {
                this.model[key] = this.terpilih[key];
            }
            this.model.tgldispos=moment(this.model.tgldispos).format('YYYY-MM-DD');

            await fa_disposal.posting(this.model);
            this.terpilih.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            for (var key in this.terpilih) {
                this.model[key] = this.terpilih[key];
            }
            this.model.tgldispos=moment(this.model.tgldispos).format('YYYY-MM-DD');
            await fa_disposal.postingUndo(this.model);
            this.terpilih.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printjv: async function()
    {
      if (this.terpilih.disposekey) {
          try {
              if ((this.terpilih.posting || 0) == 0) {
                for (var key in this.terpilih) {
                    this.model[key] = this.terpilih[key];
                }
                this.model.tgldispos=moment(this.model.tgldispos).format('YYYY-MM-DD');

                // await fa_disposal.posting(this.model);
                // this.terpilih.posting=1;
              }
              this.isprintjv=true;
              this.showReport=true;
              this.reportUrl= await fa_disposal.printjv(this.terpilih);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    editjv: function() {
        if (this.terpilih.disposekey) {
            this.saveFilter();
          router.push({name :'fixedasset.editjvfrm', params: { nomor: `DISPOSE${moment(this.terpilih.tgldispos).format('YYMM')}/${this.terpilih.asetid}`, tanggal: this.terpilih.tgldispos}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    saveFilter() {
      const keys = ['asetid', 'asdesc', 'catgid',  'tgl1', 'tgl2', 'DimCol', 'DimVal', 'nomorpo', 'tgldepr1', 'tgldepr2','uraian', 'status'];
      let filtered = false;
      const fadisposeList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              fadisposeList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          fadisposeList.page=this.tblData.page;
          fadisposeList.limit=this.tblData.limit;
          fadisposeList.sortBy=this.tblData.sortBy;
          fadisposeList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.fadisposeList=fadisposeList;
          this.$store.commit("filter", filter);
      }
    },    

    // onSelectLkuFixedAsset(lkuData) {
    //     this.lkuFixedAssetData=lkuData;
    //     this.lkuFixedAssetShow=false;
    //     this.model.asetkey = lkuData.selected.asetkey;
    //     this.model.asetid = lkuData.selected.asetid;
    //     this.model.asdesc = lkuData.selected.asdesc;
    //     this.model.lamathn = lkuData.selected.lamathn;
    //     this.model.lamabln = lkuData.selected.lamabln;
    //     this.model.depaccum = lkuData.selected.Penyusutan;
    //     this.model.catgid = lkuData.selected.catgid;
    //     this.model.catgname = lkuData.selected.catgname;
    //     this.model.matauang = lkuData.selected.matauang;
    //     this.model.asmodel = lkuData.selected.asmodel;
    //     this.model.asserial = lkuData.selected.asserial;
    //     this.model.asyermad = lkuData.selected.asyermad;
    //     this.model.supplierinfo = lkuData.selected.supplierinfo;
    //     this.model.aspurcpri = lkuData.selected.aspurcpri;
    //     this.model.asdatacq = moment(lkuData.selected.asdatacq).format('YYYY-MM-DD');
    // },
    // onSelectLkuCoa(_selected) {
    //     this.model.disposaccinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
    //     this.model.disposacc= _selected.kodeacc;
    //     this.lkuCoaShow=false;
    // },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        this.model[`${this.lkuCoaCaller}info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.model[`${this.lkuCoaCaller}`] = _selected.kodeacc;
        this.model[`${this.lkuCoaCaller}name`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },

    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
